import { Slot } from './slot';

export class Shift {
  id: string;
  slots: Slot[];
}
